import { idText } from "typescript";
import { http } from "../../../config/HttpMethod";
import { countyData, WellDetailsPayload } from "../../../store/model/calculations/calculation";
import { allProjects } from "../../../store/model/calculations/projectTab";
import { ESP_ENDPOINTS } from "../endpoints";

export const getAllProjects = async (payload:any) => {
    try {
        const response = await http.post<allProjects[]>(`${ESP_ENDPOINTS?.GET_ALL_PROJECTS}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getStatesByCountry = async () => {

    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_STATES_BY_COUNTRY}`);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getCountyByState = async (payload: string) => {
    const params = {
        stateID: payload
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_COUNTY_LIST}`, { params });
        return response?.data;

    } catch (err) {
        console.log(err, 'error');
    }
};

export const getCountryByState = async (payload: string) => {
    const params = {
        State: payload
    };
    try {

        const response = await http.get(`${ESP_ENDPOINTS?.GET_COUNTRY_BY_STATE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getWellDetails = async (payload: WellDetailsPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_WELL_DETAILS}`, payload);
        return response?.data?.data ?? response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getWellDetailsById = async (payload: number) => {
    const params = {
        Id: payload
    }
    try {

        const response = await http.get(`${ESP_ENDPOINTS?.GET_WELLS_BY_ID}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getCustomerById = async (payload: number) => {
    const params = {
        Id: payload
    }
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_CUSTOMER_BY_ID}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getProjectAndAffiliations = async (id: string) => {
    const params = {
        Id: id
    }
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_PROJECT_AFFILIATIONS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getBatchCaseCalculations = async (ids: Array<string>) => {
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_BATCH_CASE_CALCULATIONS}?${ids.map(x => `ids=${x}`).join('&')}`);
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};